import Immutable from 'immutable';

const LOAD = 'printTemplates/LOAD';
const LOAD_SUCCESS = 'printTemplates/LOAD_SUCCESS';
const LOAD_FAIL = 'printTemplates/LOAD_FAIL';

const SAVE = 'printTemplates/SAVE';
const SAVE_SUCCESS = 'printTemplates/SAVE_SUCCESS';
const SAVE_FAIL = 'printTemplates/SAVE_FAIL';

const initialState = Immutable.fromJS({
  loading: false,
  saving: false,
  body: '',
  saved: false,
  error: null
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state
        .set('loading', true)
        .set('error', null);

    case LOAD_SUCCESS:
      return state
        .set('loading', false)
        .set('body', (action.result && action.result.body) || '')
        .set('saved', false);

    case LOAD_FAIL:
      return state
        .set('loading', false)
        .set('error', action.error);

    case SAVE:
      return state
        .set('saving', true)
        .set('error', null)
        .set('saved', false);

    case SAVE_SUCCESS:
      return state
        .set('saving', false)
        .set('saved', true);

    case SAVE_FAIL:
      return state
        .set('saving', false)
        .set('error', action.error);

    default:
      return state;
  }
}

export const loadTemplate = (templateType) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get(`/print-templates/${templateType}`);
    if (res && res.message && !res.body) {
      dispatch({ type: LOAD_FAIL, error: res.message });
      return;
    }
    dispatch({ type: LOAD_SUCCESS, result: res });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, error: error.message });
  }
};

export const saveTemplate = (templateType, body) => async (dispatch, getState, api) => {
  dispatch({ type: SAVE });
  try {
    const res = await api.put(`/print-templates/${templateType}`, { data: { body } });
    if (res && res.message && res.status === 'error') {
      dispatch({ type: SAVE_FAIL, error: res.message });
      return;
    }
    dispatch({ type: SAVE_SUCCESS });
    return res;
  } catch (error) {
    dispatch({ type: SAVE_FAIL, error: error.message });
  }
};



// WEBPACK FOOTER //
// ./src/redux/modules/printTemplates.js